// frontend/src/design-system/components/PageSkeleton.tsx
import * as React from 'react';

interface Props {
  rows?: number;
}

export function PageSkeleton({ rows = 6 }: Props) {
  return (
    <div className="px-8 py-8 max-w-6xl">
      <div className="h-8 w-56 bg-muted rounded-lg animate-pulse mb-3" />
      <div className="h-4 w-80 bg-muted/60 rounded animate-pulse mb-8" />
      <div className="rounded-2xl bg-card ring-1 ring-border/50 shadow-card overflow-hidden">
        <div className="h-12 bg-muted/40 border-b border-border/60" />
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="h-16 border-b border-border/40 last:border-b-0 flex items-center px-4 gap-4">
            <div className="h-4 w-1/5 bg-muted/60 rounded animate-pulse" />
            <div className="h-4 w-1/6 bg-muted/40 rounded animate-pulse" />
            <div className="h-4 w-1/3 bg-muted/50 rounded animate-pulse" />
            <div className="h-4 w-1/6 bg-muted/40 rounded animate-pulse ml-auto" />
          </div>
        ))}
      </div>
    </div>
  );
}
